module.exports = __webpack_public_path__ + "img/책임감.5b694b7e.svg";